import { render } from "./page-eproc.vue?vue&type=template&id=082070b3&scoped=true"
import script from "./page-eproc.vue?vue&type=script&lang=js"
export * from "./page-eproc.vue?vue&type=script&lang=js"

import "./page-eproc.vue?vue&type=style&index=0&id=082070b3&scoped=true&lang=css"

import exportComponent from "D:\\project\\BahteraAdhiguna\\deployment\\ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-082070b3"]])

export default __exports__